import { SearchInteractionApplicationEvent } from '~shared/modules/application-event/models';
import { ApplicationSearchInteractionType } from '~shared/modules/application-event/constants';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';

export class SearchInputApplicationEventsHandler {
  constructor(private applicationEventService: ApplicationEventService) {
  }

  public fireSearchInteractionApplicationEvent(interactionType: ApplicationSearchInteractionType): void {
    this.applicationEventService.publish(
      new SearchInteractionApplicationEvent(interactionType)
    );
  }
}
